import { render } from "./KommentarComponent.vue?vue&type=template&id=182209fe&scoped=true"
import script from "./KommentarComponent.vue?vue&type=script&lang=js"
export * from "./KommentarComponent.vue?vue&type=script&lang=js"

import "./KommentarComponent.vue?vue&type=style&index=0&id=182209fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182209fe"]])

export default __exports__